import * as React from 'react';

type UseMobileView = (
	size?: number,
	onResize?: (setIsMobile: React.Dispatch<React.SetStateAction<boolean>>) => void,
	initValue?: boolean | (() => boolean),
) => boolean;

export const useMobileView: UseMobileView = (
	size = 520,
	onResize: (setIsMobile: React.Dispatch<React.SetStateAction<boolean>>) => void = (setIsMobile) => {
		setIsMobile(window.innerWidth < size);
	},
	initValue = false,
) => {
	const [isMobile, setIsMobile] = React.useState(initValue);

	React.useEffect(() => {
		const resize = () => {
			onResize(setIsMobile);
		};

		resize();
		window.addEventListener('resize', resize);
		return () => window.removeEventListener('resize', resize);
	}, []);

	return isMobile;
};
